import { ChatsApi } from '../../api/chats.api'
import { NetworkUtils } from '../../utils/networks.utils'
import { ChatsPagination, Chat, UpdateChat, CreateChat } from '../../models/chats.models'
import { Mode } from '../../models/commons.models'
import { sessionQuery, sessionService } from '../session'
import Constants from '../../constants'
import { logIfDev } from '../../utils/commons.utils'
import { catalogsService } from '../catalogs'

export class ChatsService {
  getChats = async (filters: ChatsApi.GetListParams): Promise<ChatsPagination> => {
    await NetworkUtils.checkConnected()

    return await ChatsApi.getList({
      ...filters,
      ...(Constants.mode === Mode.admin
        ? { platform: sessionService.getAdminPlatform() }
        : { owned: true }),
    })
  }
  getChatById = async (chatId: string): Promise<Chat> => {
    await NetworkUtils.checkConnected()
    return await ChatsApi.getById(chatId)
  }
  updateChat = async (chat: Chat, updatedChat: Partial<UpdateChat>): Promise<Chat> => {
    await NetworkUtils.checkConnected()
    const updated = await ChatsApi.update(chat._id, updatedChat)
    try {
      await this.updateStats(updated, chat)
    } catch (err) {
      logIfDev(err)
    }
    return updated
  }
  createChat = async (createChat: CreateChat): Promise<Chat> => {
    await NetworkUtils.checkConnected()
    const chat = await ChatsApi.create(createChat)
    try {
      await this.updateStats(chat)
    } catch (err) {
      logIfDev(err)
    }
    return chat
  }
  updateStats = async (currentChat: Chat, previousChat?: Chat) => {
    const w4Client =
      (!previousChat || previousChat?.clientUpToDate) && !currentChat.clientUpToDate
        ? 1
        : currentChat.clientUpToDate && previousChat?.clientUpToDate === false
        ? -1
        : 0
    const w4Seller =
      (!previousChat || previousChat?.sellerUpToDate) && !currentChat.sellerUpToDate
        ? 1
        : currentChat.sellerUpToDate && previousChat?.sellerUpToDate === false
        ? -1
        : 0

    catalogsService.updateStats(currentChat.catalog, {
      [currentChat.order ? 'orderChatsW4Client' : 'chatsW4Client']: w4Client,
      [currentChat.order ? 'orderChatsW4Seller' : 'chatsW4Seller']: w4Seller,
    })

    sessionService.updateStats({
      allChatsW4Client: currentChat.client._id === sessionQuery.getUserId() ? w4Client : 0,
      allChatsW4Seller: currentChat.seller._id === sessionQuery.getOrganizationId() ? w4Seller : 0,
    })
  }
}

export const chatsService = new ChatsService()
